export const ROSTER = [
  {
    slug: 'carmen',
    name: 'Carmen',
    email: 'carmen@ahana.digital',
    title: 'The Madrid Moto-Vlogger',
    code: 'es',
    country: 'Spain',
    city: 'Madrid',
    specialization: 'Automotive Engineering & Streetwear Culture',
    img: 'https://media.base44.com/images/public/6a68984e1435c2ee512e6e95/8add34029_carmeninspain.jpg',
    age: 26,
    attributes: {
      Hair: 'Messy textured dark chocolate brown wolf cut',
      Build: 'Voluptuous hourglass with full hips (66 kg / 146 lbs)',
      Eyes: 'Expressive hazel',
      Complexion: 'Warm olive',
    },
    appeal:
      'Men love the grease-stained mechanic fantasy; women copy her edgy, high-waisted denim and leather streetwear style.',
    bio:
      'Carmen built her audience in the back of a Madrid workshop, stripping classic café racers down to the frame on camera. Her authority is mechanical rather than aspirational — she explains torque, tyre compounds and restoration economics with the ease of someone who has scraped her knuckles for it.',
    bio2:
      'That credibility converts. Automotive, tooling and heritage denim brands use Carmen when they need an audience to believe a product performs, not merely that it looks good.',
    stats: [
      { k: 'Combined Reach', v: '4.2M' },
      { k: 'Avg. Engagement', v: '7.4%' },
      { k: 'Primary Markets', markets: ['es', 'it', 'mx'] },
    ],
    platforms: ['Instagram', 'TikTok', 'YouTube'],
    verticals: ['Performance Automotive', 'Streetwear & Denim', 'Tools & Hardware', 'Motorcycle Apparel'],
  },
  {
    slug: 'sora',
    name: 'Sora',
    email: 'sora@ahana.digital',
    title: 'The Cyberpunk Concept Artist',
    code: 'kr',
    country: 'South Korea',
    city: 'Seoul',
    specialization: 'Cyberpunk 3D Animation & Digital Art',
    img: 'https://media.base44.com/images/public/6a68984e1435c2ee512e6e95/462adc24a_sorainkoreaoriginal.jpg',
    age: 24,
    attributes: {
      Hair: 'Razor-sharp textured metallic-silver pixie cut',
      Build: 'Sleek with soft feminine curves (58 kg / 128 lbs)',
      Eyes: 'Monolid, sharp graphic eyeliner',
      Complexion: 'Glass skin with a natural sheen',
    },
    appeal:
      'Men gravitate toward the ultimate tech-gamer creative fantasy; women mimic her ultra-modern Seoul tech-wear outfits and sleek workstation aesthetics.',
    bio:
      'Sora works at the frontier of concept art — neon-drenched 3D environments rendered live for an audience that watches her build worlds frame by frame. Her studio, her hardware and her process are as much the product as the final render.',
    bio2:
      'She is the natural home for hardware, software and tech-wear launches: an audience that reads specifications carefully and buys on capability.',
    stats: [
      { k: 'Combined Reach', v: '6.8M' },
      { k: 'Avg. Engagement', v: '8.1%' },
      { k: 'Primary Markets', markets: ['kr', 'jp', 'us'] },
    ],
    platforms: ['Instagram', 'YouTube', 'Twitch', 'TikTok'],
    verticals: ['Creative Software', 'Gaming Hardware', 'Tech-wear', 'Consumer Electronics'],
  },
  {
    slug: 'chloe',
    name: 'Chloe',
    email: 'chloe@ahana.digital',
    title: 'The Eco-Surf Entrepreneur',
    code: 'au',
    country: 'Australia',
    city: 'Byron Bay',
    specialization: 'Sustainable Swimwear & Eco-Wellness',
    img: 'https://media.base44.com/images/public/6a68984e1435c2ee512e6e95/f8f641e6c_chloeinaustralia.jpg',
    age: 25,
    attributes: {
      Hair: 'Long wavy honey-blonde with sun-bleached ends',
      Build: 'Voluptuous hourglass surfer build (72 kg / 159 lbs)',
      Eyes: 'Bright blue',
      Complexion: 'Sun-kissed with light freckles',
    },
    appeal:
      'Men adore the classic beach lifestyle; women heavily subscribe to her wellness routines, beachside self-care, and sustainable swimwear line.',
    bio:
      'Chloe runs her own sustainable swimwear label, which means her audience has already watched her ship a product — sourcing, fabric trials, margins and all. That operator credibility separates her from lifestyle creators who only post.',
    bio2:
      'Wellness, ocean-conservation and premium resort brands partner with her for an audience that scrutinises supply chains as closely as silhouettes.',
    stats: [
      { k: 'Combined Reach', v: '3.1M' },
      { k: 'Avg. Engagement', v: '9.2%' },
      { k: 'Primary Markets', markets: ['au', 'us', 'gb'] },
    ],
    platforms: ['Instagram', 'TikTok', 'YouTube'],
    verticals: ['Swimwear & Resort', 'Wellness & Supplements', 'Sustainable Beauty', 'Travel'],
  },
  {
    slug: 'amelie',
    name: 'Amélie',
    email: 'amelie@ahana.digital',
    title: 'The Haute Couture Minimalist',
    code: 'fr',
    country: 'France',
    city: 'Paris',
    specialization: 'Haute Couture Minimalism & Fashion Curation',
    img: 'https://media.base44.com/images/public/6a68984e1435c2ee512e6e95/45b942da3_amelieinfrance.jpg',
    age: 23,
    attributes: {
      Hair: 'Jet-black blunt chin-length bob with straight-cut bangs',
      Build: 'Softly curved editorial frame (61 kg / 134 lbs)',
      Eyes: 'Deep-set dark brown',
      Complexion: 'Luminous fair, healthy glow',
    },
    appeal:
      'Men are drawn to her mysterious, intimidating elegance; women obsess over her quiet-luxury Paris outfits, capsule wardrobe tips, and vintage designer hauls.',
    bio:
      'Amélie is the roster\'s couture authority — a curator whose restraint is the entire point. She posts rarely and precisely, and the Paris fashion audience treats each appearance as an editorial.',
    bio2:
      'For Maisons, jewellers and quiet-luxury houses, she delivers the scarcity and taste-level that mass reach cannot buy.',
    stats: [
      { k: 'Combined Reach', v: '5.5M' },
      { k: 'Avg. Engagement', v: '6.3%' },
      { k: 'Primary Markets', markets: ['fr', 'it', 'ch'] },
    ],
    platforms: ['Instagram', 'Substack', 'TikTok'],
    verticals: ['Haute Couture', 'Fine Jewellery', 'Leather Goods', 'Fragrance'],
  },
  {
    slug: 'maya',
    name: 'Maya',
    email: 'maya@ahana.digital',
    title: 'The Retro-Soul Vinyl DJ',
    code: 'us',
    country: 'United States',
    city: 'Brooklyn',
    specialization: 'Retro-Soul Vinyl Curation & Analog Media',
    img: 'https://media.base44.com/images/public/6a68984e1435c2ee512e6e95/7c10b0e91_mayaintheus.jpg',
    age: 26,
    attributes: {
      Hair: 'Voluminous caramel-brown afro-textured coils',
      Build: 'Soft-curved hourglass silhouette (68 kg / 150 lbs)',
      Eyes: 'Deep amber',
      Complexion: 'Warm, glowing',
    },
    appeal:
      'Men love her effortless musical energy; women flock to her 1970s retro style, analog lifestyle aesthetics, and record collection vlogs.',
    bio:
      'Maya sits at the intersection of music culture and analog nostalgia — rooftop sets, crate-digging films, and a record collection her audience knows by name. Her content is warm, tactile and completely un-sterile.',
    bio2:
      'Audio hardware, spirits and heritage apparel brands use Maya to reach a culturally literate US audience that rejects overt advertising.',
    stats: [
      { k: 'Combined Reach', v: '2.9M' },
      { k: 'Avg. Engagement', v: '10.1%' },
      { k: 'Primary Markets', markets: ['us', 'gb', 'de'] },
    ],
    platforms: ['Instagram', 'TikTok', 'YouTube'],
    verticals: ['Audio Hardware', 'Premium Spirits', 'Heritage Apparel', 'Music Streaming'],
  },
  {
    slug: 'francesca',
    name: 'Francesca',
    email: 'francesca@ahana.digital',
    title: 'The Old-Money Equestrian',
    code: 'it',
    country: 'Italy',
    city: 'Tuscany',
    specialization: 'Old-Money Luxury & Equestrian Arts',
    img: 'https://media.base44.com/images/public/6a68984e1435c2ee512e6e95/a58296c62_fransescainitaly.jpg',
    age: 28,
    attributes: {
      Hair: 'Glossy chestnut brown blowout curls',
      Build: 'Tall, graceful with soft curves (64 kg / 141 lbs)',
      Eyes: 'Striking olive-green',
      Complexion: 'Sun-warmed Mediterranean',
    },
    appeal:
      'Men are mesmerised by her elite lifestyle; women look up to her tailored blazers, country estate decor, and art gala fashion.',
    bio:
      'Francesca documents a world most audiences never access: Tuscan stables, private collections, and the tailoring that accompanies them. Her register is heritage, not hype.',
    bio2:
      'She is the roster\'s highest-value placement for private banking, estate, tailoring and auction-house clients seeking genuine legacy positioning.',
    stats: [
      { k: 'Combined Reach', v: '3.7M' },
      { k: 'Avg. Engagement', v: '5.9%' },
      { k: 'Primary Markets', markets: ['it', 'at', 'gb'] },
    ],
    platforms: ['Instagram', 'YouTube'],
    verticals: ['Tailoring', 'Private Wealth', 'Equestrian Sport', 'Fine Art & Auction'],
  },
  {
    slug: 'sierra',
    name: 'Sierra',
    email: 'sierra@ahana.digital',
    title: 'The High-Altitude Alpine Explorer',
    code: 'ca',
    country: 'Canada',
    city: 'Banff',
    specialization: 'High-Altitude Alpine Exploration & Documentaries',
    img: 'https://media.base44.com/images/public/6a68984e1435c2ee512e6e95/e532f7a92_sierraincanada.jpg',
    age: 25,
    attributes: {
      Hair: 'Vibrant copper-red, wind-tossed',
      Build: 'Voluptuous athletic hourglass (71 kg / 156 lbs)',
      Eyes: 'Light green',
      Complexion: 'Fair, heavily freckled',
    },
    appeal:
      'Men love the rugged, adventurous outdoor energy; women are inspired by her solo mountain camping, fitness stamina, and gear reviews.',
    bio:
      'Sierra films long-form documentary work at altitude — solo ascents, winter camps and honest gear reviews conducted in genuinely punishing conditions.',
    bio2:
      'Technical outerwear, optics and expedition brands rely on her because her audience buys equipment on evidence of failure as much as success.',
    stats: [
      { k: 'Combined Reach', v: '4.0M' },
      { k: 'Avg. Engagement', v: '8.7%' },
      { k: 'Primary Markets', markets: ['ca', 'us', 'ch'] },
    ],
    platforms: ['YouTube', 'Instagram', 'TikTok'],
    verticals: ['Technical Outerwear', 'Optics & Cameras', 'Expedition Gear', 'Automotive 4x4'],
  },
  {
    slug: 'elena',
    name: 'Elena',
    email: 'elena@ahana.digital',
    title: 'The Urban Ballet-Core Dancer',
    code: 'ru',
    country: 'Russia',
    city: 'Moscow',
    specialization: 'Contemporary Dance & Clean-Girl Ballet-Core',
    img: 'https://media.base44.com/images/public/6a68984e1435c2ee512e6e95/ce0bab9bb_elenainrussia.jpg',
    age: 23,
    attributes: {
      Hair: 'Platinum-blonde, flawless slicked-back ballerina bun',
      Build: 'Lithe dancer frame, healthy and toned (57 kg / 126 lbs)',
      Eyes: 'Icy blue',
      Complexion: 'Porcelain with a rosy glow',
    },
    appeal:
      'Men are captivated by her flexibility, poise and classical grace; women obsess over her ballet-core outfits, clean-girl skincare, and stretching vlogs.',
    bio:
      'Elena trained classically and now translates that discipline into short-form movement content — precise, restrained and unmistakably technical.',
    bio2:
      'Skincare, activewear and fragrance brands select Elena for a clean, aspirational register that performs exceptionally with 18–30 female audiences.',
    stats: [
      { k: 'Combined Reach', v: '5.2M' },
      { k: 'Avg. Engagement', v: '11.3%' },
      { k: 'Primary Markets', markets: ['ru', 'gb', 'fr'] },
    ],
    platforms: ['Instagram', 'TikTok', 'YouTube'],
    verticals: ['Skincare', 'Activewear', 'Fragrance', 'Wellness Tech'],
  },
  {
    slug: 'naomi',
    name: 'Naomi',
    email: 'naomi@ahana.digital',
    title: 'The Neon-Noir 3D Animator',
    code: 'jp',
    country: 'Japan',
    city: 'Tokyo',
    specialization: 'Alternative Tokyo Night-Owl Digital Design',
    img: 'https://media.base44.com/images/public/6a68984e1435c2ee512e6e95/b8d37b971_naomiinjapan.png',
    age: 24,
    attributes: {
      Hair: 'Ink-black shaggy wolf cut with asymmetrical purple streaks',
      Build: 'Compact voluptuous hourglass (68 kg / 150 lbs)',
      Eyes: 'Dark, soulful',
      Complexion: 'Smooth, matte',
    },
    appeal:
      'Men love her tech-savvy alternative night-owl energy; women look up to her Japanese streetwear style, digital art time-lapses, and Tokyo nightlife vlogs.',
    bio:
      'Naomi\'s work lives after midnight — animation time-lapses, analog photography and the Tokyo bars and record shops that inform her palette.',
    bio2:
      'A precise fit for cameras, creative tools and alternative fashion brands seeking authentic subcultural credibility in Japan and beyond.',
    stats: [
      { k: 'Combined Reach', v: '6.1M' },
      { k: 'Avg. Engagement', v: '9.6%' },
      { k: 'Primary Markets', markets: ['jp', 'kr', 'us'] },
    ],
    platforms: ['Instagram', 'TikTok', 'YouTube'],
    verticals: ['Cameras & Optics', 'Creative Software', 'Alternative Fashion', 'Nightlife & Music'],
  },
  {
    slug: 'thandi',
    name: 'Thandi',
    email: 'thandi@ahana.digital',
    title: 'The Coastal Botanist & Chef',
    code: 'za',
    country: 'South Africa',
    city: 'Cape Town',
    specialization: 'Farm-to-Table Culinary Arts & Coastal Botanics',
    img: 'https://media.base44.com/images/public/6a68984e1435c2ee512e6e95/86b098317_thandiinsouthafrica.jpg',
    age: 26,
    attributes: {
      Hair: 'Long golden-brown cascading bohemian box braids',
      Build: 'Voluptuous natural hourglass with full hips (74 kg / 163 lbs)',
      Eyes: 'Striking light hazel-green',
      Complexion: 'Rich dark chocolate, luminous',
    },
    appeal:
      'Men are drawn to her nurturing earth-goddess warmth; women follow her organic farm-to-table recipes, garden aesthetics, and coastal slow-living vlogs.',
    bio:
      'Thandi cooks from her own garden on the Cape coast — botanicals, preserving, and long-form recipe films with genuine agricultural knowledge behind them.',
    bio2:
      'Food, kitchenware and hospitality brands work with Thandi to reach an audience that values provenance and craft over convenience.',
    stats: [
      { k: 'Combined Reach', v: '7.4M' },
      { k: 'Avg. Engagement', v: '10.8%' },
      { k: 'Primary Markets', markets: ['za', 'gb', 'us'] },
    ],
    platforms: ['Instagram', 'YouTube', 'TikTok'],
    verticals: ['Food & Beverage', 'Kitchenware', 'Hospitality & Travel', 'Natural Skincare'],
  },
];

export const getTalent = (slug) => ROSTER.find((m) => m.slug === slug);